import React from "react";
import { useState } from "react";
import { phoneWhatsapp } from "../../shared/config/phone";

const GridHomeCare = () => {
  // --- LISTA DE SERVIÇOS ---
  const services = [
    {
      name: "Fisioterapia",
      description: "Reabilitação e manutenção da mobilidade, promovendo autonomia e qualidade de vida no domicílio."
    },
    {
      name: "Cuidados Paliativos",
      description: "Assistência focada no conforto, alívio da dor e bem-estar do paciente e da família."
    },
    {
      name: "Cuidados de Enfermagem",
      description: "Atendimento de enfermagem qualificado para cuidados contínuos, curativos e monitoramento clínico."
    },
    {
      name: "Terapia Ocupacional",
      description: "Estimulação da independência nas atividades diárias, adaptando rotinas e ambientes."
    },
    {
      name: "Fonoaudiologia",
      description: "Tratamento de distúrbios da fala, comunicação, voz e deglutição no ambiente domiciliar."
    },
    {
      name: "Acompanhamento Médico",
      description: "Avaliação e acompanhamento clínico periódico com foco na evolução do paciente."
    },
    {
      name: "Serviços de Saúde Mental",
      description: "Apoio psicológico e emocional para pacientes e familiares, promovendo equilíbrio e bem-estar."
    },
    {
      name: "Acompanhamento Hospitalar",
      description: "Suporte ao paciente durante internações, garantindo cuidado contínuo e humanizado."
    },
    {
      name: "Atendimento Pré-Hospitalar",
      description: "Atendimento inicial e estabilização do paciente em situações de urgência."
    },
    {
      name: "Terapia Medicamentosa Domiciliar",
      description: "Administração segura de medicamentos conforme prescrição médica, no conforto do lar."
    },
    {
      name: "Cuidadores",
      description: "Profissionais treinados para auxiliar nas atividades diárias e no cuidado contínuo do paciente."
    },
    {
      name: "Aluguel de Equipamentos",
      description: "Locação de equipamentos hospitalares para garantir suporte e segurança no atendimento domiciliar."
    }
  ];
  const [selectedService, setSelectedService] = useState(services[0]);

  // --- ÍCONES (mantidos) ---
  const InternacaoIcon = (props) => (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_356_7831)">
        <rect x="4" width="48" height="48" rx="6" fill="white" />
        <path d="M48 17.4453V18.7727C47.6556 19.833 46.4346 20.3809 45.4986 19.6733C44.6909 19.0628 44.91 18.0798 44.7858 17.1834C43.687 9.19187 35.1737 7.54097 30.0718 13.0697C29.287 13.9202 28.9489 15.09 27.49 14.6382C26.8639 14.4441 26.6542 13.8273 26.2461 13.3817C24.8759 11.8832 23.3012 10.7238 21.3018 10.2031C13.2925 8.11493 9.46167 16.0397 12.0298 22.756C12.3951 23.7098 13.208 24.6448 12.5234 25.6727C12.0664 26.3594 11.1658 26.5514 10.4499 26.1319C9.87283 25.7938 9.57437 24.9683 9.31974 24.3725C5.62662 15.7277 10.572 5.3109 20.9105 6.92214C23.5976 7.34165 26.172 8.78906 28.0421 10.7259C30.964 7.60359 35.4367 6.14052 39.6578 7.00145C43.9145 7.86865 46.7101 11.3948 47.6493 15.4918L48 17.4453Z" fill="#108AFF" />
        <path d="M45.7042 34.388C44.2244 33.2223 42.0914 32.2382 40.6983 31.0361C40.3873 30.7679 40.0325 30.2419 40.0325 29.8266V22.6793H36.9864V25.3748C36.9864 25.4823 36.8298 26.0479 36.7672 26.171C36.5794 26.5394 36.0232 26.9161 35.612 26.9683C35.0433 27.0413 34.7532 26.8493 34.3055 26.5707C32.2048 25.2652 30.2169 23.4776 28.1245 22.1252L27.9054 22.0657L10.3738 34.3034C8.76773 35.2395 7.14501 33.1482 8.51415 31.8198L27.3241 18.6804C27.8167 18.4727 28.231 18.5093 28.71 18.7305L33.8609 22.3673V20.6871C33.8609 20.1988 34.7532 19.6081 35.228 19.5549C37.2629 19.3253 39.7111 19.726 41.7898 19.5549C42.488 19.6405 43.0233 20.156 43.159 20.8416L43.1715 28.8749L47.4156 31.8166C48.7399 33.0741 47.3572 35.1205 45.7042 34.388Z" fill="#108AFF" />
        <path d="M38.08 34.9819C36.3049 36.7152 31.1696 40.0295 28.878 41.0126C27.9169 41.4248 27.6581 41.238 26.7784 40.8143C24.6662 39.7979 22.2327 38.1793 20.323 36.8029C19.6405 36.3103 18.3882 35.4734 17.8456 34.9067C16.9846 34.0072 17.3676 32.4387 18.6084 32.2269C18.7983 32.1945 19.0175 32.1904 19.2084 32.2154C19.7876 32.2926 21.5794 33.8632 22.1982 34.3025C24.061 35.6278 26.004 36.8655 28.0421 37.9059C30.0123 36.8571 31.9116 35.6717 33.7294 34.3808C34.3838 33.9164 36.0712 32.4168 36.6879 32.2624C38.319 31.8512 39.3281 33.764 38.08 34.9819Z" fill="#108AFF" />
        <path d="M29.2151 31.5851C28.8926 31.8167 27.249 31.8021 26.8785 31.654C26.601 31.5423 26.4736 31.3732 26.4392 31.0769C26.3943 30.6981 26.3881 29.57 26.4455 29.2058C26.4841 28.9605 26.7231 28.6861 26.9652 28.6318C27.2448 28.5692 28.5952 28.5713 28.8968 28.6193C29.3413 28.6903 29.5229 29.1066 29.5636 29.5147C29.6158 30.0291 29.6617 31.2637 29.2151 31.5851Z" fill="#108AFF" />
      </g>
      <defs>
        <filter id="filter0_d_356_7831" x="0" y="0" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_356_7831" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_356_7831" result="shape" />
        </filter>
      </defs>
    </svg>

  );

  const AssistenciaIcon = (props) => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="6" fill="#108AFF" />
      <path d="M38.5293 10.6018C36.392 9.96 34.0188 10.3649 31.8105 10.2512V8.10339C31.8105 7.90615 31.5287 7.06812 31.4337 6.83852C30.7961 5.3044 29.3454 4.31504 27.7477 4.00195H20.2482C18.4636 4.2159 16.1864 6.22383 16.1864 8.10339V10.2512C13.57 10.3639 10.8336 9.83998 8.39992 11.0182C5.95575 12.2027 4.35274 14.6083 4 17.2821V36.9679C4.1388 37.4835 4.1962 38.0178 4.35066 38.5313C5.24713 41.5192 8.06804 43.7003 11.1582 43.9884L36.7698 43.9978C40.6187 43.6711 43.6619 40.6164 43.9958 36.7717L44 17.5524C43.7579 14.3964 41.5746 11.516 38.5293 10.6018ZM19.311 8.41544C19.311 7.65672 20.2409 7.17353 20.9088 7.12343C22.9699 6.96897 25.2283 7.23823 27.3093 7.13491C27.8729 7.12761 28.6859 7.86962 28.6859 8.41544V10.2512H19.311V8.41544ZM36.4619 40.8773L11.3836 40.8732C9.10645 40.6196 7.33333 38.8266 7.12148 36.5411L7.12565 17.7131C7.27176 15.9295 8.51785 14.1856 10.2492 13.6889V15.2115C10.2492 15.8742 11.1415 16.4952 11.7729 16.5066C12.4356 16.5192 13.3738 15.9118 13.3738 15.2115V13.3758H34.623V15.2115C34.623 15.8742 35.5143 16.4952 36.1467 16.5066C36.8094 16.5192 37.7477 15.9118 37.7477 15.2115V13.6889C39.4508 14.1752 40.7011 15.8899 40.8618 17.6432L40.8754 36.5411C40.6531 38.8694 38.8028 40.7135 36.4619 40.8773Z" fill="white" />
      <path d="M23.2016 16.212C15.3243 16.787 10.5654 25.4021 14.406 32.3829C18.5658 39.945 29.5124 39.9325 33.6201 32.3339C37.7257 24.7384 31.7698 15.5869 23.2016 16.212ZM30.7011 31.1337C27.5723 36.4437 19.7065 36.0951 16.99 30.5796C14.574 25.6756 17.8624 19.8208 23.2799 19.3366C29.623 18.771 33.953 25.614 30.7011 31.1337Z" fill="white" />
      <path d="M28.6911 27.0864C28.7036 27.7491 28.0962 28.6883 27.397 28.6883H25.5612V30.5241C25.5612 31.2233 24.622 31.8307 23.9593 31.8181C23.3279 31.8067 22.4356 31.1868 22.4356 30.5241V28.6883H20.5999C19.9372 28.6883 19.3172 27.796 19.3047 27.1636C19.2932 26.5019 19.9006 25.5627 20.5999 25.5627H22.4356V23.7269C22.4356 23.0642 23.3279 22.4443 23.9593 22.4318C24.622 22.4203 25.5612 23.0277 25.5612 23.7269V25.5627H27.397C28.0597 25.5627 28.6796 26.455 28.6911 27.0864Z" fill="white" />
    </svg>
  );

  const EmergenciasIcon = (props) => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="6" fill="#108AFF" />
      <path d="M43.3757 22.9556C43.215 23.5098 42.8549 24.7142 42.4792 25.1056C41.5962 26.023 39.9931 25.521 39.8 24.2644C39.6998 23.6058 40.1789 22.7855 40.3667 22.1342C43.3475 11.7954 33.1882 5.57498 25.638 13.4997C25.2852 13.8702 25.1642 14.3002 24.6246 14.5163C23.13 15.1154 22.6478 13.7012 21.8139 12.8746C17.5838 8.67892 10.2027 8.66953 7.84813 14.8492C4.24736 24.2957 14.1354 32.3509 21.291 36.4442C22.0675 36.8889 24.3762 37.9106 24.8218 38.4607C25.5775 39.3937 24.9961 40.8611 23.8084 40.9655C23.201 41.0198 22.9442 40.8559 22.4359 40.6128C14.6468 36.8847 4.63353 29.2198 4 19.8683V17.759C4.65127 10.569 9.90213 5.58855 17.3615 7.09251C19.9123 7.60705 22.1113 8.9388 24.0286 10.6442C25.6338 9.13188 27.5657 7.93268 29.7032 7.32943C39.777 4.48954 46.0309 13.8139 43.3757 22.9556Z" fill="white" />
      <path d="M42.5533 31.8211C40.6329 32.0152 38.4108 31.676 36.457 31.8252C36.099 31.7929 35.6649 31.6457 35.4039 31.3952C34.8654 30.8797 34.3112 28.5021 33.9793 27.662C33.9469 27.5795 33.9563 27.4292 33.8446 27.448L31.7739 39.9473C31.4911 41.3896 29.5331 41.6433 28.8662 40.3543L26.0231 31.8305L20.622 31.8012C18.8821 31.4871 18.879 29.0334 20.622 28.7171C22.6802 28.8946 25.3969 28.403 27.3789 28.7161C27.596 28.7505 27.9081 28.8914 28.0886 29.0219C28.742 29.4978 29.2993 31.9828 29.6448 32.8575C29.6782 32.9399 29.6677 33.0902 29.7805 33.0714L31.8512 20.5722C32.1361 19.1235 34.0889 18.8636 34.7589 20.1651L37.6009 28.689C39.179 28.8069 40.9209 28.5595 42.4792 28.6942C44.5165 28.8706 44.4726 31.628 42.5533 31.8211Z" fill="white" />
    </svg>

  );

  const ContactArrowIcon = (props) => (
    <svg width="30" height="30" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="53.605" height="53.605" rx="26.8025" fill="white" />
      <path d="M20.8025 14.8027H38.8025V32.8027" stroke="black" strokeWidth="4" strokeMiterlimit="10" />
      <path d="M38.8025 14.8027L14.8025 38.8027" stroke="black" strokeWidth="4" strokeMiterlimit="10" />
    </svg>
  );

  return (
    <section className="flex w-full flex-col items-center py-10 sm:py-14 px-4 sm:px-6 rounded-lg">
      <div className="w-full max-w-7xl rounded-lg bg-gradient-to-b from-[#FFFFFF] to-[#EBEBEB] shadow-lg">
        {/* IMAGEM PRINCIPAL */}
        <div className="p-6 sm:p-10 md:p-12">
          <div className="overflow-hidden rounded-t-lg">
            <img
              src="https://images.pexels.com/photos/7551675/pexels-photo-7551675.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="Cuidador ajudando paciente na cama"
              className="block w-full h-[220px] sm:h-[280px] md:h-[400px] object-cover rounded"
            />
          </div>
          {/* CARDS PRINCIPAIS */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 pt-6">
            {/* Internação */}
            <div className="flex flex-col rounded-lg bg-[#108AFF] px-5 sm:px-7 pt-7 sm:pt-9 text-white shadow-xl h-auto sm:h-[290px]">
              <div className="mb-4 flex items-center">
                <InternacaoIcon />
                <h2 className="text-lg sm:text-xl font-semibold pl-3">Internação Domiciliar</h2>
              </div>
              <p className="text-sm leading-relaxed text-blue-100">
                Atendimento em casa para pacientes com quadros clínicos complexos, que exigem cuidados diários, mas não precisam de internação hospitalar.
              </p>
            </div>

            {/* Assistência */}
            <div className="flex flex-col rounded-lg border border-gray-200 bg-gradient-to-t from-[#FFFFFF]/60 to-[#EBEBEB]/80 px-5 sm:px-7 pt-7 sm:pt-9 h-auto sm:h-[290px] text-gray-600 shadow-xl">
              <div className="mb-4 flex items-center">
                <AssistenciaIcon />
                <h2 className="text-lg sm:text-xl font-semibold pl-3 text-[#108AFF]">
                  Assistência Domiciliar
                </h2>
              </div>
              <p className="text-sm leading-relaxed">
                Voltada para pacientes estáveis, com atendimentos similares aos realizados em ambulatórios, como consultas e pequenos procedimentos.
              </p>
            </div>

            {/* Emergências */}
            <div className="flex flex-col rounded-lg border border-gray-200 bg-gradient-to-t from-[#FFFFFF]/60 to-[#EBEBEB]/80 px-5 sm:px-7 pt-7 sm:pt-9 h-auto sm:h-[290px] text-gray-600 shadow-xl">
              <div className="mb-4 flex items-center">
                <EmergenciasIcon />
                <h2 className="text-lg sm:text-xl font-semibold pl-3 text-[#108AFF]">
                  Emergências Médicas
                </h2>
              </div>
              <p className="text-sm leading-relaxed">
                Atendimento 24h com estrutura completa: médicos especializados, equipamentos modernos e protocolos clínicos seguros.
              </p>
            </div>
          </div>
        </div>

        {/* PARTE INFERIOR */}
        <div className="p-6 sm:p-10 md:p-14 pt-0 flex flex-col gap-10 lg:flex-row items-start shadow-xl rounded-md">
          {/* BLOCO TEXTO */}
          <div className="w-full lg:w-2/5 rounded-lg shadow-2xl bg-gradient-to-t from-[#FFFFFF]/60 to-[#EBEBEB]/80 px-5 sm:px-6 py-6 sm:py-8">
            <p className="text-sm sm:text-base leading-relaxed text-gray-700">
              <b>{selectedService.name}</b> — {selectedService.description}
            </p>
            <a className="mt-5 inline-flex items-center justify-center rounded-full bg-black py-2 pl-5 pr-2 text-xs sm:text-sm text-white 
            transition-colors hover:bg-gray-700" href={`https://wa.me/${phoneWhatsapp}?text=${encodeURIComponent(`Quero saber mais sobre ${selectedService.name}`)}`}>
              <p className="pr-2 text-center sm:text-left">
                Entre em contato com um profissional
              </p>
              <ContactArrowIcon />
            </a>
          </div>

          {/* BLOCO DE SERVIÇOS */}
          <div className="w-full lg:w-3/5">
            <div className="flex flex-wrap justify-center lg:justify-end gap-2 sm:gap-3">
              {services.map((service) => (
                <div
                  key={service.name}
                  onClick={() => setSelectedService(service)}
                  className={`inline-flex cursor-pointer items-center justify-center shadow-md py-1.5 px-4 text-center text-sm sm:text-base font-medium rounded transition-all
                  ${selectedService.name === service.name
                      ? "bg-[#108AFF] text-white"
                      : "bg-white text-[#108AFF] hover:text-blue-700"
                    }`}
                >
                  {service.name}
                  <span className="ml-2 font-bold">
                    <svg width="10" height="10" viewBox="0 0 13 13" fill="none">
                      <rect y="6.36328" width="9" height="9" transform="rotate(-45 0 6.36328)" fill="currentColor" />
                    </svg>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GridHomeCare;
